// extracted by mini-css-extract-plugin
module.exports = {"center":"AccessDenied_center__Id_Hy"};